module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_oval_grey.9ab71da3.png";